export default __webpack_public_path__ + "static/media/logo_masvida.ece24e8c.png";